module.exports = __webpack_public_path__ + "media/images/gallery/constellations/canis_minor/cmi_names-f16b79b08477fd29a3d4742f1ff331ed.gif";